// extracted by mini-css-extract-plugin
export default {"productDescription":"t--z","featuredDescription":"u--z","description":"v--z","more":"w--z","descriptionSku":"x--z"};